<template>
  <div class="notification-container">
    <div class="notification-header">
      <div class="icon">
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="17"
            height="17"
            fill="white"
            fill-opacity="0.01"
            style="mix-blend-mode:multiply"
          />
          <path
            d="M15.9374 5.67447L14.8749 2.48697C14.8379 2.37701 14.766 2.28218 14.67 2.21695C14.5741 2.15171 14.4595 2.11968 14.3436 2.12572H2.65613C2.54028 2.11968 2.42564 2.15171 2.32971 2.21695C2.23378 2.28218 2.16184 2.37701 2.12488 2.48697L1.06238 5.67447C1.05473 5.73088 1.05473 5.78806 1.06238 5.84447V9.03197C1.06238 9.17287 1.11835 9.30799 1.21798 9.40762C1.31761 9.50725 1.45273 9.56322 1.59363 9.56322H2.12488V14.8757H3.18738V9.56322H6.37488V14.8757H14.8749V9.56322H15.4061C15.547 9.56322 15.6822 9.50725 15.7818 9.40762C15.8814 9.30799 15.9374 9.17287 15.9374 9.03197V5.84447C15.945 5.78806 15.945 5.73088 15.9374 5.67447ZM13.8124 13.8132H7.43738V9.56322H13.8124V13.8132ZM14.8749 8.50072H12.7499V6.37572H11.6874V8.50072H9.03113V6.37572H7.96863V8.50072H5.31238V6.37572H4.24988V8.50072H2.12488V5.92947L3.03863 3.18822H13.9611L14.8749 5.92947V8.50072Z"
            fill="#161616"
          />
        </svg>
      </div>
      <div>
        <strong>Inventory notifications</strong>
      </div>
    </div>
    <div class="notification-header">
      <div>
        <p>
          Add stock threshold limit and get notified when your item runs low.
        </p>
      </div>
      <div>
        <button @click="showModel">
          SETUP
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showModel: {
      type: Function,
      required: true
    }
  }
}
</script>

<style scoped>
.notification-container {
  display: flex;
  border: black 1px solid;
  border-radius: 10px;
  padding: 10px;
  flex-direction: column;
}

.notification-header {
  display: flex;
  margin-left: 10px;
  flex-direction: row;

  strong {
    font-size: 12px;
  }

  .icon {
    padding: 5px;
  }

  p {
    font-size: 12px;
    margin-left: 10px;
    padding-top: 4px;
  }

  button {
    text-transform: uppercase;
    border-radius: 40px;
    border: 1px solid #24292c;
    background: #dfdad2;
    height: 25px;
    margin-left: 5px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #24292c;
    padding: 0 1rem;
    font-size: 0.813rem;
  }
}
</style>
